export const PRESCREEN_PROCESS_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  ERROR: "ERROR",
};
export const PRESCREEN_DATA_STATUS = {
  REJECT: "REJECT",
  PASS: "PASS",
  ERROR: "ERROR",
};

export const HISTORY_PROCESS_STATUS = {
  INITIAL: "INITIAL",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
  DOWNLOADED: "DOWNLOADED",
  DELETED: "DELETED",
};
export const PAGINATION_ROWS_PER_PAGE = 10;

export const USER_UPLOAD_TRANSACTION_MASTER_PROCESS_STATUS = {
  INITIAL: "INITIAL",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  OVER_LIMIT: "OVER_LIMIT",
};
export const USER_UPLOAD_TRANSACTION_ROW_PROCESS_STATUS = {
  INITIAL: "INITIAL",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
};
export const USER_UPLOAD_TRANSACTION_ROW_DATA_STATUS = {
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};

export const PARTNER = {
  ALL: "ALL",
  GENERALI: "GENERALI",
  TISCO: "TISCO",
  AGENCY: "AGENCY",
  RETAIL: "RETAIL",
  KKP: "KKP",
  SSW: "SSW",
  TG: "TG",
  ICBC: "ICBC",
  KA: "KA",
  TSR: "TSR",
};

export const TISCO_BROKER_NAME = {
  BROKER_TISCO_BANK: "TISCO Bank",
  BROKER_INSURANCE_SOLUTION: "TISCO Insurance Solution",
  BROKER_HI_WAY: "Hi-Way",
};

export const TISCO_BROKER_CODE = {
  TISBANK: "TISBNK",
  TISINS: "TISINS",
  TISHI: "TISHI",
  TISINB: "TISINB",
};

export const RETAIL_BROKER_CODE = { RTBMKT: "RTBMKT" };

export const AGENCY_BROKER_CODE = { AGCUSR: "AGCUSR" };

export const KA_BROKER_CODE = { KALMKT: "ONLINE_KA" };

export const LICENSE_TYPE = {
  UNIT_LINKED: "UNL",
  OIC_Life: "OIC",
  SEC_SINGLE: "SSL",
  LIFE: "LF",
  NON_LIFE: "NLF",
  NON_LIFE_HI: "NL",
};

export const CHANNEL_CODE = {
  DIRECT: "Direct",
};
